// This file is auto-generated during build process
  // DO NOT EDIT MANUALLY - Changes will be overwritten
  import { Environment } from './environment.model';

  const HOST_URL = 'https://yss-admin-staging.youngstrokeservice.org.au';

  export const environment: Environment = {
    name: 'production',
    production: true,
    sentry_dsn: 'https://399e5882f025f2730449edc0c75f199d@o4508515734650880.ingest.us.sentry.io/4511222603907072',
    hostURL: HOST_URL,
    apiURL: `${HOST_URL}/api/v1`,
    cmsApiURL: `${HOST_URL}/spina/api`,
    cmsToken: '4bmsrr65ah3oas5d4sd54st11k',
    GA: 'G-07RK6J8W7R',
    GTM: 'GTM-P87QC7VK',
    googleSiteVerification: 'yHhl18PWeOgA2fWeSI-DqGNMRiVjTAJa4sfFrMSipPQ',
  };

  export const PAGE_MAP = {
    'introduction-to-get-involved': 9,
  'introduction-to-get-referral': 10,
  'introduction-for-gps': 11,
  'about-the-program': 12,
  } as const;
  